import { Component, Input } from '@angular/core';
import { DocumentTypeRequirementTextDto } from '../api/models/document-type-requirement-text-dto.model';

@Component({
    selector: 'nova-doc-type-text-reqs',
    template: `
        @for (requirement of getOrderedRequirements(); track requirement) {
            <div class="req">
                @if (requirement.association?.id) {
                    <h4 class="req__title">Association : {{ requirement.association.name }}</h4>
                }
                @if (requirement.facility?.id) {
                    <h4 class="req__title">Facility : {{ requirement.facility.name }}</h4>
                }
                <span
                    class="req__text"
                    [innerHTML]="requirement.comments"></span>
            </div>
        }
    `,
    styles: [
        `
            :host {
                margin-top: 16px;
                overflow: auto;
                max-height: 10vh;
            }
        `,

        `
            req {
                margin-bottom: 32px;

                &__title {
                    margin: 0 0 8px;
                    padding-bottom: 5px;
                    color: #4d4d4d;
                    font-weight: 500;
                    border-bottom: 1px solid;
                }

                &__text {
                    color: #7a7a7a;
                }
            }
        `
    ],
    standalone: true
})
export class DocumentTypeTextRequirementsComponent {
    @Input() requirements: DocumentTypeRequirementTextDto[];
    getOrderedRequirements() {
        if (!this.requirements) {
            return this.requirements;
        }

        return this.requirements.sort((a, b) => {
            let weightA = 3;
            let weightB = 3;
            if (a.association && a.association.id && (!a.facility || !a.facility.id)) {
                weightA = 0;
            } else if (a.association && a.association.id && a.facility && a.facility.id) {
                weightA = 1;
            } else if ((!a.association || !a.association.id) && a.facility && a.facility.id) {
                weightA = 2;
            }

            if (b.association && b.association.id && (!b.facility || !b.facility.id)) {
                weightB = 0;
            } else if (b.association && b.association.id && b.facility && b.facility.id) {
                weightB = 1;
            } else if ((!b.association || !b.association.id) && b.facility && b.facility.id) {
                weightB = 2;
            }

            return weightA - weightB;
        });
    }
}
